'use client'

import { logger } from '@/lib/logger'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Gửi error tới Sentry để theo dõi và debug
    logger.captureException(error as Error)
  }, [error])

  console.error('🚀 ~ Lookback2025 Error:', error)

  return (
    <div className='flex min-h-screen flex-col items-center justify-center bg-black px-6 text-white'>
      <div className='max-w-md text-center'>
        <h2 className='mb-4 text-2xl font-semibold'>
          Đã có lỗi xảy ra khi tải Lookback 2025
        </h2>
        <p className='mb-6 text-neutral-400'>
          Vui lòng thử lại hoặc liên hệ bộ phận hỗ trợ nếu vấn đề vẫn tiếp tục.
        </p>
        <button
          onClick={reset}
          className='rounded-full bg-white px-8 py-3 text-base font-semibold text-black transition-colors hover:bg-gray-100'
        >
          Thử lại
        </button>
      </div>
    </div>
  )
}

